import { render, staticRenderFns } from "./PdvClientSearchModal.vue?vue&type=template&id=f8edca68"
import script from "./PdvClientSearchModal.vue?vue&type=script&lang=js"
export * from "./PdvClientSearchModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports